import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { images } from './data';

@Injectable()
export class ImageServices {
  setGroupFilter$ = new Subject<any>();
  getGroupFilter = this.setGroupFilter$.asObservable();

  constructor() {}

  fetchImages(): Observable<any> {
    return of(images);
  }
}
